import React, { useEffect, useState } from 'react';
import '../../../styles/globals.css'
import { Box, Button, TextField, Typography } from '@mui/material'
import karmaStyles from '../../../styles/KarmaPool.module.css'
import DashboardLogoutFooterComponent from '../footer/DashboardLogoutFooterComponent';
import AdminDashboardMenuHeaderComponent from './header/AdminDashboardMenuHeaderComponent';
import { useKarmaPoolContext } from '../../../state/KarmaPoolContext';

function AdminDashboardCycles() {
    
    function RedirectIfNotLoggedIn() {
        if (window.localStorage.getItem("jwtAuthToken") == null) {
            window.location.href = "/karma";
        }
    }

    const karmaContext = useKarmaPoolContext();

    const [gbpInCycle, setGbpInCycle] = useState(() => {
        return karmaContext.local.cycle.gbpInCycle;
    });

    useEffect(() => {
        setGbpInCycle(karmaContext.local.cycle.gbpInCycle);
    }, [karmaContext.local]);

    const handleGbpInCycleChange = (event) => {
        setGbpInCycle(event.target.value);
    };

    const handleSubmit = (event) => {
        // Prevent page reload
        event.preventDefault();

        console.log("Setting GBP in cycle to: " + gbpInCycle);

        fetch(karmaContext.getURLBasePath() + 'cycle/' + karmaContext.local.cycle.id, {
            method: 'PATCH',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                "gbpInCycle": gbpInCycle,
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                karmaContext.refresh();
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    RedirectIfNotLoggedIn();

    return (
        <>
            <Box className={karmaStyles.homepageBox}>
                <AdminDashboardMenuHeaderComponent
                    cycleEnabled={true} />
                <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        Admin - Current Cycle
                    </Typography>

                    <Box>
                        <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                            <div>
                                <Box sx={{}}>
                                    <TextField
                                        sx={{
                                            margin: "0.25rem",
                                            width: "11rem", input: { color: 'white' },
                                            label: { color: 'white' }
                                        }}
                                        id="gbpInCycle"
                                        label="Gbp In Cycle"
                                        defaultValue={gbpInCycle}
                                        variant='filled'
                                        onChange={handleGbpInCycleChange}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Box>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="info"
                                    sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "1.0rem", marginBottom: "0.75rem" }}>
                                    Save
                                </Button>
                            </div>
                        </form>
                    </Box>

                </Box>
            </Box>
            <DashboardLogoutFooterComponent />
        </>
    );
}

export default AdminDashboardCycles;
